<template>
  <div class="orders-charts">
    <AlgoliaCurrentFilters/>
    <ais-stats v-show="false">
      <div slot-scope="{ nbHits }">
        {{ totalResults = nbHits }}
      </div>
    </ais-stats>

    <EntityPerDayChart
      :mainDateFilter="mainDateFilter"
      :title="$t('orders.orders_per_day')"
      entity="orders"
    />

    <MetricsPerDay :indexName="indexName" :mainDateFilter="mainDateFilter"/>

    <wrld-box :headerTitle="$t('orders.customer')" class="customers-pie-charts"> <!-- TODO: add to i18n -->
      <template v-slot:boxContent>
        <v-row>
          <v-col md="6" class="border-right">
            <PieChart
              :totalResults="totalResults"
              :label="$t('orders.by_customers')"
              attribute="buyer.name"
              color="#255aee"
            />
          </v-col>
          <v-col md="6">
            <PieChart
              :totalResults="totalResults"
              :label="$t('orders.by_country')"
              attribute="delivery.country"
              color="#7D02EB"
            />
          </v-col>
        </v-row>
      </template>
    </wrld-box>

  </div>
</template>

<script>
import AlgoliaCurrentFilters from '@/components/general/AlgoliaCurrentFilters'
import MetricsPerDay from '@/components/reports/orders/charts/MetricsPerDay'
import PieChart from '@/components/reports/PieChart'
import EntityPerDayChart from '@/components/reports/EntityPerDayChart'

export default {
  name: 'OrdersCharts',
  components: {
    AlgoliaCurrentFilters,
    MetricsPerDay,
    PieChart,
    EntityPerDayChart
  },
  props: {
    indexName: String
  },
  data () {
    return {
      totalResults: 0,
      mainDateFilter: 'pickup.ts'
    }
  }
}
</script>

<style lang="scss" scoped>
  .border-right {
    border-right: 1px lightgray solid;
  }
</style>
